import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { SnackbarType } from 'src/app/models/snackbar-type.enum';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-modal-msg-rpa-v2',
  templateUrl: './modal-msg-rpa-v2.component.html',
  styleUrls: ['./modal-msg-rpa-v2.component.scss']
})
export class ModalMsgRpaV2Component {

  rpa = new FormGroup({
    UserMsg: new FormControl<string>('', {})
  });

  constructor(
    public dialogRef: MatDialogRef<ModalMsgRpaV2Component>,
    private _snackbarService: SnackbarService
  ) { }

  close(action: boolean): void {
    if (action) {
      if (this.rpa.controls['UserMsg'].invalid) {
        return this._snackbarService.openSnackBar('Mensagem de e-mail obrigatória!', SnackbarType.Danger);
      }
      this.dialogRef.close({ save: action, msg: this.rpa.controls['UserMsg'].value });
    } else {
      this.dialogRef.close({ save: action });
    }
  }
}
